import React, { forwardRef } from 'react'
import { Input as ChakraInput, InputGroup, InputLeftElement, InputRightElement, InputProps } from '@chakra-ui/core'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import styled from '@emotion/styled'
import colors from 'constants/colors'
import useLocaleText from 'components/useLocaleText'

interface InputWithIcon extends InputProps {
  icon?: React.ReactNode
  elementProps?: any
}

const StyledInput = styled(ChakraInput)`
  &:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: black;
  }
`

export const InputWithIcon = forwardRef<HTMLInputElement, InputWithIcon>(({ icon, elementProps, ...props }, ref) => {
  const isRtl = useSelector(isRtlSelector)
  const search = useLocaleText('search')

  if (!icon) {
    return (
      <StyledInput
        ref={ref}
        _focus={{ boxShadow: '0px 0px 0px 1px #000000' }}
        border={`1px solid ${colors.greyBorder}`}
        borderRadius="5px"
        placeholder={search}
        _placeholder={{ fontSize: '12px' }}
        {...props}
      />
    )
  }

  return (
    <InputGroup>
      <StyledInput
        ref={ref}
        borderRadius="5px"
        border={`1px solid ${colors.greyBorder}`}
        pr={isRtl ? '35px' : '10px'}
        pl={isRtl ? '10px' : '35px'}
        placeholder={search}
        _focus={{ boxShadow: '0px 0px 0px 1px #000000' }}
        _placeholder={{ fontSize: '12px' }}
        {...props}
      />
      {isRtl ? (
        <InputRightElement {...elementProps}>{icon}</InputRightElement>
      ) : (
        <InputLeftElement {...elementProps}>{icon}</InputLeftElement>
      )}
    </InputGroup>
  )
})
